// HENYA Batch 3B: keeps the thumbnail rail in sync with the selected colour
// variant. The main gallery slider and the media modal are already filtered
// natively by sections/main-product.liquid on every variant-triggered
// section re-render; only the thumbnail rail is not replaced by that flow,
// so it is kept in sync here.
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const sectionId = event && event.data && event.data.sectionId;
    const variant = event && event.data && event.data.variant;
    if (!sectionId || !variant) return;

    const mapScript = document.querySelector(`[data-variant-media-map="${sectionId}"]`);
    if (!mapScript) return;

    let map;
    try {
      map = JSON.parse(mapScript.textContent);
    } catch (error) {
      return;
    }

    const allowedMediaIds = map[String(variant.id)];
    if (!allowedMediaIds) return;

    const allowedSet = new Set(allowedMediaIds);
    const thumbnails = document.getElementById(`GalleryThumbnails-${sectionId}`);
    if (!thumbnails) return;

    thumbnails.querySelectorAll('[data-media-numeric-id]').forEach((item) => {
      const isAllowed = allowedSet.has(item.dataset.mediaNumericId);
      item.hidden = !isAllowed;
      if (isAllowed) {
        item.removeAttribute('aria-hidden');
      } else {
        item.setAttribute('aria-hidden', 'true');
      }
    });

    if (typeof thumbnails.resetPages === 'function') {
      thumbnails.resetPages();
    } else if (typeof thumbnails.initPages === 'function') {
      thumbnails.initPages();
    }
  });
}
